import { render } from "./RecipientBlock.vue?vue&type=template&id=408de7b1&scoped=true"
import script from "./RecipientBlock.vue?vue&type=script&lang=js"
export * from "./RecipientBlock.vue?vue&type=script&lang=js"

import "./RecipientBlock.vue?vue&type=style&index=0&id=408de7b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408de7b1"]])

export default __exports__